import { giphyBlue, giphyDarkGrey, giphyGreen, giphyPurple, giphyRed, giphyYellow } from '@giphy/js-brand'
export const PRESET_COLORS = ['#fff', giphyDarkGrey, '#000', giphyRed, giphyYellow, giphyGreen, giphyBlue, giphyPurple]
export const margin = 6
